"use client"

import { Button } from "@/components/ui/button"
import { Skeleton } from "@/components/ui/skeleton"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { sortingOptions } from "@/components/filters/helpers"
import { ArrowUpDown } from "lucide-react"

interface ProductsHeaderProps {
  totalCount: number
  sortBy: string
  onSortChange: (value: string) => void
  isLoading: boolean
  searchQuery?: string
}

export function ProductsHeader({
  totalCount,
  sortBy,
  onSortChange,
  isLoading,
  searchQuery,
}: ProductsHeaderProps) {
  return (
    <div className="flex justify-between items-center max-sm:hidden">
      {isLoading ? (
        <Skeleton className="h-8 w-[98%] rounded-md block" />
      ) : (
        <>
          <span className="text-[#828282] text-base font-gilroySemiBold">
            {totalCount} Results found
            {searchQuery && ` for "${searchQuery}"`}
          </span>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="sm" className="font-gilroyMedium">
                <ArrowUpDown className="w-4 h-4 mr-2" />
                Sort By
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="end"
              className="w-[200px] font-gilroyMedium"
            >
              <DropdownMenuRadioGroup
                value={sortBy}
                onValueChange={onSortChange}
              >
                {sortingOptions.map((opt) => (
                  <DropdownMenuRadioItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </DropdownMenuRadioItem>
                ))}
              </DropdownMenuRadioGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </>
      )}
    </div>
  )
}
